<template>
  <div class='rank-no-data'>
    <img class="img" :src="image" alt="">
    <p>快去学习争夺日榜首吧~~</p>
  </div>
</template>
<script setup>
import NoDataImg from "@/assets/img/rank/no-data.png"
const image = NoDataImg
</script>
<style lang="scss" scoped>
.rank-no-data {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: transparent;
  border-radius: 0.12rem;
  padding: 0.46rem 0 0.48rem;
  .img {
    width: 3.20rem;
  }
  p {
    margin-top: 0.14rem;
    color: #969799;
    font-size: 0.28rem;
  }
}
</style>
